module.exports = __webpack_public_path__ + "static/media/HL7.cdb2eb09.jpg";